export enum CurrencyEnum {
    USD = 'USD',
    JPY = 'JPY',
    EUR = 'EUR',
    SEK = 'SEK',
    GBP = 'GBP',
    AUD = 'AUD',
}
